import { ModalStore } from 'ui/base/modal';
import { StringStore } from 'ui/base/input/store';

export class TimezoneStore {
  name: StringStore;
  label: StringStore;
  offset: StringStore;
  search: StringStore;
  modal: ModalStore;

  constructor(name: string) {
    this.name = new StringStore(name);
    this.label = new StringStore('');
    this.offset = new StringStore('');
    this.search = new StringStore('');
    this.modal = new ModalStore(false);
  }
}
